<style lang="scss">
</style>

<template>
<div class="side-nav">
    <div class="logo">
        <router-link to="/secret-santa">
            <img src="../assets/icon-cheshire.png" alt="Mad Chatters" />
        </router-link>
    </div>
    <div class="nav-item">
        <router-link to="/secret-santa">secret santa</router-link>
    </div>
    <div class="nav-item">
        <router-link to="/account">account</router-link>
    </div>
    <div class="nav-item" v-if="isAdmin">
        <router-link to="/admin">admin</router-link>
    </div>
    <div class="nav-item">
        <a @click="logout">logout</a>
    </div>
</div>
</template>

<script>
import { auth } from '../core/auth.js';
export default {
    name: 'SideNav',
    data: function() {
        return {
            myAuth: auth.session,
        };
    },
    computed: {
        isAdmin: function() {
            return this.myAuth.isAdmin;
        }
    },
    methods: {
        logout: async function() {
            await auth.logout();
            this.$router.push('/login');
        },
    },
};
</script>
